var React = require('react');

function Open (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.99935 18.0006L9.03377 0.0350662M17.9998 8.99978L-0.000787108 9.00022","strokeWidth":"1.25"}));
}

Open.defaultProps = {"width":"15","height":"12","viewBox":"0 0 18 19","fill":"black"};

module.exports = Open;

Open.default = Open;
